// extracted by mini-css-extract-plugin
module.exports = {"major":"money_major__vqUWs","minor":"money_minor__4_TdU","symbol":"money_symbol__YNzO6"};